export const EXPORT_ITEM_LEVEL_BREAKDOWN = {
  method: 'GET',
  url: 'v2/analyseit/order/%s/analytics/export',
};

export const EXPORT_ORDER_BREAKDOWN_ORDER = {
  method: 'GET',
  url: 'v2/analyseit/order/export',
};

// Mirror orders export (order breakdown, mirror-only logic)
export const EXPORT_MIRROR_ORDER_BREAKDOWN_ORDER = {
  method: 'GET',
  url: 'v2/analyseit/order/mirror/export',
};

export const EXPORT_ORDER_BREAKDOWN_ITEM = {
  method: 'GET',
  url: 'v2/analyseit/order/menus/export',
};

export const PAYMENT_METHOD = {
  method: 'GET',
  reducerKey: 'paymentMethodAnalytics',
  url: 'v2/analyseit/order/payment/summary',
};

export const PROMO_SUMMARY = {
  method: 'GET',
  url: 'v2/analyseit/order/promo/summary',
};

export const PROMO_LIST = {
  method: 'GET',
  url: 'v2/analyseit/order/promo/analytics',
  isPaginated: false,
};

export const BRANCH_LIST = {
  method: 'GET',
  reducerKey: 'branches',
  url: 'v1/branch',
  isPaginated: false,
};

export const BRAND_LIST = {
  method: 'GET',
  reducerKey: 'brands',
  url: 'v1/brand',
  isPaginated: false,
};

export const CITY_LIST = {
  method: 'GET',
  url: 'v1/cities',
  reducerKey: 'cities',
  isPaginated: false,
};

export const MENU_REPORT = {
  method: 'GET',
  url: 'v2/analyseit/order/%s/analytics',
  isPaginated: false,
};

export const OOS_ITEM_ANALYTICS = {
  method: 'GET',
  url: 'v2/analyseit/menu/item/oos/analytics',
  isPaginated: false,
};

export const OOS_ITEM_LOGS = {
  method: 'GET',
  url: 'v2/analyseit/menu/item/oos/logs',
  isPaginated: false,
};

export const OOS_MODIFIER_ANALYTICS = {
  method: 'GET',
  url: 'v2/analyseit/menu/modifier/oos/analytics',
  isPaginated: false,
};

export const OOS_MODIFIER_LOGS = {
  method: 'GET',
  url: 'v2/analyseit/menu/modifier/oos/logs',
  isPaginated: false,
};

export const ORDER_ANALYTICS = {
  method: 'GET',
  url: 'v1/analyseit/order/analytics',
  isPaginated: false,
};

export const ORDER_BREAKDOWN_LIST = {
  method: 'GET',
  reducerKey: 'orderBreakdown',
  url: 'v1/analyseit/order',
  isPaginated: true,
};

export const ORDER_STATUS_LIST = {
  method: 'GET',
  reducerKey: 'orderStatusList',
  url: 'v1/oni/statuses',
  isPaginated: false,
};

export const ORDER_SUMMARY = {
  method: 'GET',
  reducerKey: 'orderSummary',
  url: 'v2/analyseit/order/summary',
};

export const PAYMENT_METHOD_ANALYTICS = {
  method: 'GET',
  url: 'v2/analyseit/order/payment/summary',
  isPaginated: false,
};

export const PAUSE_STORE_LOGS = {
  method: 'GET',
  url: 'v2/analyseit/busymode/logs',
  isPaginated: false,
};

export const PROMO_ANALYTICS = {
  method: 'GET',
  url: 'v2/analyseit/order/promo/analytics',
  isPaginated: false,
};

export const PROVIDER_LIST = {
  method: 'GET',
  reducerKey: 'analyticsProviders',
  url: 'v1/provider',
  isPaginated: false,
};

export const PREV_REPORT_LIST = {
  method: 'GET',
  loaderKey: 'isLoadingPrevReports',
  reducerKey: 'previousOrderReports',
  url: 'public/analyseit/%s/files?type=%s',
  isPaginated: true,
};

export const CASH_MOVEMENTS_LIST = {
  method: 'GET',
  reducerKey: 'cashMovements',
  url: 'v1/oni/cash/activities',
  isPaginated: true,
};

export const CASH_ACTIVITIES_BY_SHIFT = {
  method: 'GET',
  reducerKey: 'cashActivitiesByShift',
  url: 'v1/oni/cash/activities/shift/%s',
  isPaginated: false,
};

export const EXPORT_CASH_MOVEMENTS_CSV = {
  method: 'GET',
  url: '/v1/oni/cash/activities/export/csv',
};

export const EXPORT_CASH_MOVEMENTS_EXCEL = {
  method: 'GET',
  url: '/v1/oni/cash/activities/export/excel',
};

export const CASH_SHIFTS_LIST = {
  method: 'GET',
  reducerKey: 'cashShifts',
  url: 'v1/oni/cash/shifts',
  isPaginated: true,
};

export const EXPORT_CASH_SHIFTS_CSV = {
  method: 'GET',
  url: '/v1/oni/cash/shifts/export/csv',
};

export const EXPORT_CASH_SHIFTS_EXCEL = {
  method: 'GET',
  url: '/v1/oni/cash/shifts/export/excel',
};

export const GET_SIGNED_PREV_REPORT = {
  method: 'GET',
  url: 'public/analyseit/signed-url?file-path=%s.%s',
};

export default {
  PAYMENT_METHOD,
};
